// import React from 'react';
import styled from 'styled-components';

import { Button } from '../../../UI/Button';

// import ReusableSelectBox from '../../../UI/ReusableSelectbox';

const SidebarCaption = styled.h4`
  font-size: 16px;
  font-weight: 500;
  color: #0a080d;
`;

const RewardsHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 24px;
`;

const RewardsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const RewardsContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const RewardCaption = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #6a6f83;
  text-transform: uppercase;
`;

const RewardItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RewardValue = styled.h3`
  margin: 0;

  color: ${props => props.theme.text0};
  font-family: Bebas Neue;
  font-size: 32px;
  font-weight: 600;

  sup {
    margin-right: 4px;

    position: relative;
    top: 0;

    font-family: Poppins, sans-serif;
    font-size: 12px;
    color: ${props => props.theme.text2};
  }
`;

const APR = styled(RewardItem)`
  align-items: flex-end;

  ${RewardValue} {
    color: ${props => props.theme.accent0};
  }
`;

const Allocation = styled.div`
  padding-top: 30px;
  margin-top: 40px;

  border-top: 1px solid #e6e6f3;
`;

const AllocationChart = styled.div`
  width: 100%;
  height: 4px;

  background: linear-gradient(to right, #1652f0 60%, #f3ba2f 60% 80%, #d8d8eb 80%);
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 27px;

  margin-top: 40px;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  strong {
    font-size: 14px;
    font-weight: 400;
    color: #6a6f83;
  }
`;

const InfoRowValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.text2};
`;

// const Change = styled.div`
//   color: ${props => props.theme.text0};
//   font-family: Bebas Neue;
//   font-size: 20px;
//   font-weight: 600;
// `;

// const Chart = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   flex-direction: column;

//   width: 220px;
//   height: 220px;
//   margin: 0 auto;

//   border-radius: 50%;
//   border: 12px solid #00baff;

//   h3 {
//     margin-bottom: 4px;

//     color: ${props => props.theme.text0};
//     font-family: Bebas Neue;
//     font-size: 32px;
//     font-weight: 600;

//     sup {
//       position: relative;
//       top: 4px;

//       font-size: 20px;
//     }
//   }

//   span {
//     font-size: 12px;
//     font-weight: 500;
//     color: #6a6f83;
//     text-transform: uppercase;
//   }
// `;

// const options = [
//   { value: 'hour', label: 'Hour' },
//   { value: 'day', label: 'Day' },
//   { value: 'week', label: 'Week' },
//   { value: 'month', label: 'Month' },
//   { value: 'year', label: 'Year' },
// ];

export default function StakingSidebar() {
  return (
    <div>
      <RewardsHeader>
        <SidebarCaption>Rewards</SidebarCaption>

        {/*<ReusableSelectBox options={options} placeholder="" />*/}
      </RewardsHeader>

      <RewardsContentWrapper>
        <RewardsContent>
          <RewardItem>
            <RewardCaption>total reward</RewardCaption>
            <RewardValue>
              9554.09 NOM <sup>$12,045</sup>
            </RewardValue>
          </RewardItem>
          <APR>
            <RewardCaption>APR</RewardCaption>
            <RewardValue>3.54%</RewardValue>
          </APR>
        </RewardsContent>

        <Button>Claim</Button>
      </RewardsContentWrapper>

      <Allocation>
        <SidebarCaption>Allocation</SidebarCaption>
        <AllocationChart />
      </Allocation>

      <InfoWrapper>
        <InfoRow>
          <strong>My Validators</strong>
          <InfoRowValue>5</InfoRowValue>
        </InfoRow>
        <InfoRow>
          <strong>Total Staked</strong>
          <InfoRowValue>$98,334.54</InfoRowValue>
        </InfoRow>
        <InfoRow>
          <strong>Available</strong>
          <InfoRowValue>$12,345</InfoRowValue>
        </InfoRow>
        <InfoRow>
          <strong>Unstaking</strong>
          <InfoRowValue>$12,345</InfoRowValue>
        </InfoRow>
        <InfoRow>
          <strong>Rewards</strong>
          <InfoRowValue>$2,335</InfoRowValue>
        </InfoRow>
      </InfoWrapper>
    </div>
  );
}
